/* eslint-disable */
import * as Types from '../../../../../../generated/graphql'

import { gql } from '@apollo/client'
export type GQLInterestsFragment = {
  __typename?: 'PublicProfile'
  interests: {
    __typename?: 'PublicInterests'
    interestsCount: number
    interests: {
      __typename?: 'PublicInterestsConnection'
      nodes: Array<{
        __typename?: 'PublicInterest'
        interestId: number
        text: string
        matchMy?: boolean | null
      }>
      pageInfo: {
        __typename?: 'PageInfo'
        hasNextPage: boolean
        endCursor: any
      }
    }
  }
}

export const InterestsFragmentDoc = gql`
  fragment Interests on PublicProfile {
    interests {
      interestsCount
      interests(limit: $limitInterest, after: null) {
        nodes {
          interestId
          text
          matchMy @include(if: $authorized)
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
